import React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'clsx';
import { css } from 'linaria';
import { ModalContent } from 'fronton-react';
import { List, Typography } from 'common/components';

const servicesModalText = css`
  margin-bottom: 24px;
`;

const servicesModalList = css`
  && {
    li {
      margin-bottom: 0;
    }
  }
`;

export const Services = () => {
  const { t } = useTranslation();

  return (
    <>
      <ModalContent>
        <Typography className={servicesModalText} variant="m" size="body_long">
          {t('utp-section.services.modal-description-first')}
        </Typography>
        <Typography variant="m" size="body_long">
          {t('utp-section.services.modal-description-second')}
        </Typography>
        <List className={cn(servicesModalText, servicesModalList)} listStyle="disc">
          <li>
            <Typography variant="m" size="body_long">
              {t('utp-section.services.modal-item-first')}
            </Typography>
          </li>
          <li>
            <Typography variant="m" size="body_long">
              {t('utp-section.services.modal-item-second')}
            </Typography>
          </li>
          <li>
            <Typography variant="m" size="body_long">
              {t('utp-section.services.modal-item-third')}
            </Typography>
          </li>
          <li>
            <Typography variant="m" size="body_long">
              {t('utp-section.services.modal-item-fourth')}
            </Typography>
          </li>
        </List>
        <Typography variant="m" size="body_long">
          {t('utp-section.services.modal-description-third')}
        </Typography>
      </ModalContent>
    </>
  );
}
